<template>
  <!-- <transition name="el-zoom-in-top"> -->
  <div class="content-wrapper">
    <!-- Main content -->
    <section class="content">
      <!-- Default box -->
      <div class="box">
        <div class="box-header with-border">
          <h3 class="box-title">Create Publisher</h3>
        </div>
        <div class="box-body">
          <h5>Enter Publisher's Name</h5>
          <!-- <p :class="{ 'control': true }"> -->
          <el-input
            class
            v-validate="'required'"
            data-vv-delay="1000"
            :class="{'input': true, 'is-danger': errors.has('name') }"
            name="name"
            type="text"
            placeholder="Publisher name"
            v-model="credentials.name"
          ></el-input>
          <span
            v-show="errors.has('name')"
            class="help is-danger"
            style="color:red"
          >{{ errors.first('name') }}</span>
          <hr />

          <h5>Enter E-Mail</h5>
          <!-- <p :class="{ 'control': true }"> -->
          <el-input
            class
            v-validate="'required|email'"
            data-vv-delay="1000"
            :class="{'input': true, 'is-danger': errors.has('email') }"
            name="email"
            type="text"
            placeholder="Please enter email address"
            v-model="credentials.email"
          ></el-input>
          <span
            v-show="errors.has('email')"
            class="help is-danger"
            style="color:red"
          >{{ errors.first('email') }}</span>
          <hr />
          <span>enable AMP Setup</span>
          <el-switch
            v-model="credentials.amp_ss_enable"
            active-color="#13ce66"
            inactive-color="#ff4949"
          ></el-switch>
          <hr />
          <!-- <h5>Enter Password</h5>
					
					<el-input class="" v-validate="'required'" data-vv-delay="1000" :class="{'input': true, 'is-danger': errors.has('password') }" name="password" type="password" placeholder="Enter password for creator" v-model="credentials.password"></el-input>
					
					<hr>

					<h5>Re-Enter Password</h5>
					
					<el-input class="" v-validate="'required'" data-vv-delay="1000" :class="{'input': true, 'is-danger': errors.has('repassword') }" name="repassword" type="password" placeholder="Reenter the password" v-model="credentials.repassword"></el-input>
					
          <hr>-->

          <!-- <h5>Enter Contact Number</h5> -->
          <!-- <p :class="{ 'control': true }"> -->
          <!-- <el-input class = "" v-validate="'required'" data-vv-delay="1000" :class="{'input': true, 'is-danger': errors.has('number') }" name="number" type="number" placeholder="Contact Number" v-model="credentials.number"></el-input>
					<span v-show="errors.has('number')" class="help is-danger">{{ errors.first('number') }}</span>
          <hr>-->

          <button class="el-button el-button--success" @click="submit()" :disabled="!formValid">
            <i class="el-icon-plus el-icon-left"></i>
            Create Publisher
          </button>
          <!-- <button :disabled="!isactivateaccount" class="el-button el-button--success" @click="sentemail()">
						<i class="fa fa-envelope" aria-hidden="true"></i>
							Account Activate Mail
          </button>-->
          <router-link to="/admin/AllPublisher/" class="el-button el-button--danger">Cancel</router-link>
        </div>
        <!-- /.box-body -->
      </div>
      <!-- /.box -->
    </section>
    <!-- /.content -->
  </div>
  <!-- </transition> -->
</template>
<script>
import axios from "axios";
export default {
  data() {
    return {
      credentials: {
        name: "",
        email: "",
        amp_ss_enable: false,
      },
      message: "",
      countryOptions: [],
      currenciesOptions: [],
      isactivateaccount: false,
    };
  },
  created: function () {
    console.log(this.$route.params);
    this.$nextTick(function () {
      const self = this;
      axios
        .all([
          axios.get(BASE_URL + "v1/countries/"),
          axios.get(BASE_URL + "v1/currencies/"),
        ])
        .then(
          axios.spread(function (countries, currencies) {
            self.countryOptions = countries.data;
            self.currenciesOptions = currencies.data;
          })
        )
        .catch((error) => console.log(error));
    });
  },
  methods: {
    sentemail() {
      axios
        .post(BASE_URL + "v1/auth/password/reset/nivid/", {
          email: this.credentials.email,
          activateOrReset: "activate",
        })
        .then((response) => {
          this.$notify({
            title: "Success",
            message: "Successfully created a new publisher",
            type: "success",
          });

          setTimeout(() => {
            // this.$router.push('/admin/create-domain/?publisher='+response.data.id);
            // this.$router.push('/admin/AllPublisher/')
            this.$router.push("/admin/AllPublisher/");
          }, 1000);
        })
        .catch((error) => {
          this.$notify({
            title: "Warning",
            message: "Unable to create a new publisher",
            type: "warning",
          });
        });
    },
    submit() {
      console.log("calling create func");
      const createPublisher = (userId) => {
        axios
          .post(BASE_URL + "v1/publishers/", {
            name: this.credentials.name,
            owner: userId,
            contact_email: this.credentials.email,
            amp_ss_enable: this.credentials.amp_ss_enable,
          })
          .then((response) => {
            this.isactivateaccount = true;
            this.$notify({
              title: "Success",
              message: "Successfully created a new publisher",
              type: "success",
            });

            setTimeout(() => {
              this.$router.push("/admin/publishers/");
            }, 1000);
          })
          .catch((error) => {
            this.$notify({
              title: "Warning",
              message: "Unable to create a new publisher",
              type: "warning",
            });
          });
      };

      if (this.credentials.password == this.credentials.repassword) {
        let splitName = this.credentials.name.split(" "),
          firstName = splitName[0],
          lastName;

        if (splitName.length > 1) {
          splitName.shift();
          lastName = splitName.join(" ");
        } else lastName = splitName[0];

        axios
          .post(BASE_URL + "v1/users/", {
            first_name: firstName,
            last_name: lastName,
            email: this.credentials.email,
            password: this.credentials.password,
          })
          .then((response) => {
            createPublisher(response.data.id);
          })
          .catch((error) => {
            this.$notify({
              title: "Warning",
              message: "Unable to create a new user",
              type: "warning",
            });
          });
      } else {
        this.$notify({
          title: "Warning",
          message: "Password and Repassword does not match",
          type: "error",
        });
      }
    },
  },
  computed: {
    formValid() {
      return this.credentials.name && this.credentials.email;
      // return  this.credentials.name && this.credentials.email && this.credentials.password && this.credentials.repassword;
    },
  },
};
</script>
<style scoped>
input[type="number"]::-webkit-inner-spin-button,
input[type="number"]::-webkit-outer-spin-button {
  -webkit-appearance: none;
  margin: 0;
}
.el-select {
  display: block;
}
.content-wrapper .content {
  padding-top: 95px;
}
button[disabled="disabled"],
button:disabled {
  background-color: rgba(200, 200, 200, 2.3);
  cursor: not-allowed;
  border-color: rgba(200, 200, 200, 2.3);
}
</style>



// WEBPACK FOOTER //
// AddPublisher.vue?62861cda